export const PrincipalInformationDisabledFields: { [key: string]: boolean } = {
  email: true,
  firstName: true,
  middleName: true,
  lastName: true,
  suffix: true,
};

export const PrincipalInformationInputPlaceholder = "-";
